import { API_URL, ApiError } from '../../shared/api/http'

const key = 'spectra-portaria-resident-session'
const clientKey = 'spectra-portaria-resident-client'

export type ResidentProfile = {
  clientId: string; personId: string; unitId: string; name: string;
  clientName: string; unitLabel: string; blockName: string | null
}
export type ResidentSession = { accessToken: string; expiresAt: string }

export function savedResidentClient(): string {
  return localStorage.getItem(clientKey) ?? ''
}

export function saveResidentClient(clientId: string) {
  localStorage.setItem(clientKey, clientId)
}

export function residentToken(): string | null {
  return sessionStorage.getItem(key) ?? localStorage.getItem(key)
}

export function saveResidentSession(session: ResidentSession, remember: boolean) {
  sessionStorage.removeItem(key)
  localStorage.removeItem(key)
  ;(remember ? localStorage : sessionStorage).setItem(key, session.accessToken)
}

export function clearResidentSession() {
  sessionStorage.removeItem(key)
  localStorage.removeItem(key)
}

export async function residentApi<T>(path: string, body?: unknown,
  method: 'GET' | 'POST' | 'PUT' = body === undefined ? 'GET' : 'POST'): Promise<T> {
  const token = residentToken()
  const headers = new Headers()
  if (body !== undefined) headers.set('Content-Type', 'application/json')
  if (token) headers.set('Authorization', `Portaria ${token}`)
  const response = await fetch(`${API_URL}/portaria/residents/${path}`, {
    method, headers, body: body === undefined ? undefined : JSON.stringify(body),
    credentials: 'omit', cache: 'no-store',
  })
  const payload = response.status === 204 || !response.headers.get('content-type')?.includes('json')
    ? null : await response.json()
  if (!response.ok) {
    const code = payload && typeof payload === 'object' && 'code' in payload
      ? String(payload.code) : 'generic_error'
    throw new ApiError(code, response.status)
  }
  return payload as T
}
